module.exports = __webpack_public_path__ + "static/media/advices.5a16e7a4.svg";